import React from "react";
import { Link } from "react-router-dom";
import { useAdminContext } from "../../../context/adminContext";
import Sidebar from "../../../Layout/Sidebar";
import { ImageUrl } from "../../../utils/BaseUrl";
import Header from "../../common/Header";




export default function Userreports() {
    const { adminDetail, } = useAdminContext()
    return (
        <>
            {/*<Sidebar />*/}
            <div className="main-content vh-100 vh_md-auto overflow-y-a">
                <Header title="System & Reports" />
                <div className="container-fluid">
                    <div className="row">


                        <div className="col-12">
                            <nav className="mb-5">
                                <ol className="breadcrumb">
                                    <li className="breadcrumb-item">
                                        <Link to="/dashboard">
                                            <i className="fe fe-home"></i> Dashboard
                                        </Link>
                                    </li>
                                    <li className="breadcrumb-item">
                                        <Link to="#!">
                                            System & Reports
                                        </Link>
                                    </li>
                                    <li className="breadcrumb-item active" aria-current="page">
                                        Users
                                    </li>
                                </ol>
                            </nav>
                        </div>
                        <div className="d-flex justify-content-end mb-4 flex-wrap">
                            {/* <div>
                                <h2 className="report">Users Reports</h2>
                            </div> */}

                            <div style={{ display: "-webkit-inline-box" }}>
                                {/* <div className="dropdown">
                                    <button
                                        className="btn btn-sm btn-white"
                                        type="button"
                                        data-bs-toggle="dropdown"
                                        data-bs-auto-close="outside"
                                        aria-haspopup="true"
                                        aria-expanded="false"
                                    >
                                        <i className="fe fe-sliders me-1"></i> Filter{" "}
                                        <img src="/images/chevron-down.svg" alt="" width={17} />{" "}
                                        <span className="badge bg-primary ms-1 d-none">0</span>
                                    </button>

                                    <form className="dropdown-menu dropdown-menu-end dropdown-menu-card">
                                        <table className="table mb-0">
                                            <tr>
                                                <td>
                                                    {" "}
                                                    <input type="radio" name="" id="mon" />{" "}
                                                    <label htmlFor="mon"> user1</label>{" "}
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    {" "}
                                                    <input type="radio" name="" id="yer" />{" "}
                                                    <label htmlFor="yer"> user2</label>{" "}
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    {" "}
                                                    <input type="radio" name="" id="day" />{" "}
                                                    <label htmlFor="day"> user3</label>{" "}
                                                </td>
                                            </tr>
                                        </table>
                                    </form>
                                </div> */}
                                <div className="position-relative">
                                    <input
                                        className="form-search me-3"
                                        type="search"
                                        name=""
                                        id=""
                                        placeholder="Search"
                                    />
                                    <img
                                        className="users-search"
                                        src="/images/Icon feather-search.svg"
                                        alt=""
                                    />
                                </div>
                                <span data-bs-toggle="modal" data-bs-target="#exampleModal" className="invite-vindor">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-download" viewBox="0 0 16 16">
                                        <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z" /> <path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z" />
                                    </svg> <span className="ms-2"> Download Report</span></span>
                            </div>
                        </div>
                        <hr />
                    </div>
                    <div className="card table-responsive">
                        <table className="table table-sm table-hover table-nowrap card-table">
                            <thead>
                                <tr>
                                    <th>
                                        <span
                                            className="list-sort text-muted"

                                        >
                                            S.No
                                        </span>
                                    </th>
                                    <th>
                                        <span
                                            className="list-sort text-muted"

                                        >
                                            User Name
                                        </span>
                                    </th>
                                    <th>
                                        <span
                                            className="list-sort text-muted"
                                           
                                        >
                                            Home Address
                                        </span>
                                    </th>
                                    <th>
                                        <span
                                            className="list-sort text-muted"

                                        >
                                            Email
                                        </span>
                                    </th>
                                    <th>
                                        <span
                                            className="list-sort text-muted"
                                            
                                        >
                                            Work Address
                                        </span>
                                    </th>
                                    <th colSpan={2}>
                                        <span
                                            className="list-sort text-muted"
                                         
                                        >
                                            Contact
                                        </span>
                                    </th>
                                </tr>
                            </thead>
                            <tbody className="list fs-base">
                                <tr>
                                    <td>1</td>
                                    <td>
                                        {/* Avatar */}
                                        <div className="avatar avatar-xs align-middle me-2">
                                            <img
                                                className="avatar-img rounded-circle"
                                                src="/images/profiledp.png"
                                                alt=""
                                            />
                                        </div>
                                        <Link
                                            className="item-name text-reset"
                                        >
                                            Jhon Joe
                                        </Link>
                                    </td>
                                    <td>
                                        <span className="item-title">
                                            Virtual Office & Mailing...
                                        </span>
                                    </td>
                                    <td>
                                        <a
                                            className="item-email text-reset"
                                            href="mailto:user231@gmail.com"
                                        >
                                            user231@gmail.com
                                        </a>
                                    </td>
                                    <td>
                                        10th floor SPE Tower...
                                    </td>
                                    <td>
                                        <a
                                            className="item-phone text-reset"
                                            href="tel:+89687677578"
                                        >
                                            +89687677578
                                        </a>
                                    </td>
                                    <td className="text-end">
                                        <div className="dropdown">
                                            <Link
                                                className="dropdown-ellipses dropdown-toggle"
                                                href=""
                                                role="button"
                                                data-bs-toggle="dropdown"
                                                aria-haspopup="true"
                                                aria-expanded="false"
                                            >
                                                <i className="fe fe-more-vertical" />
                                            </Link>
                                            <div className="dropdown-menu dropdown-menu-end">
                                                <Link to="/ventoredit" className="dropdown-item">
                                                    Edit
                                                </Link>
                                                <Link to="" className="dropdown-item">
                                                    Remove
                                                </Link>
                                                {/* <Link to="" data-bs-toggle="modal" data-bs-target="#exampleModal" className="dropdown-item">
                                                        Remove
                                                    </Link> */}
                                                {/* <Link to="#!" className="dropdown-item">
                                                        Other
                                                    </Link> */}
                                            </div>
                                        </div>
                                    </td>
                                </tr>

                                <tr>
                                    <td>2</td>
                                    <td>
                                        {/* Avatar */}
                                        <div className="avatar avatar-xs align-middle me-2">
                                            <img
                                                className="avatar-img rounded-circle"
                                                src="/images/profiledp.png"
                                                alt=""
                                            />
                                        </div>
                                        <a
                                            className="item-name text-reset"
                                            href=""
                                        >
                                            Jhon Joe
                                        </a>
                                    </td>
                                    <td>
                                        <span className="item-title">
                                            Virtual Office & Mailing...
                                        </span>
                                    </td>
                                    <td>
                                        <a
                                            className="item-email text-reset"
                                            href="mailto:user231@gmail.com"
                                        >
                                            user231@gmail.com
                                        </a>
                                    </td>
                                    <td>
                                        10th floor SPE Tower...
                                    </td>
                                    <td>
                                        <a
                                            className="item-phone text-reset"
                                            href="tel:+89687677578"
                                        >
                                            +89687677578
                                        </a>
                                    </td>
                                    <td className="text-end">
                                        <div className="dropdown">
                                            <a
                                                className="dropdown-ellipses dropdown-toggle"
                                                href=""
                                                role="button"
                                                data-bs-toggle="dropdown"
                                                aria-haspopup="true"
                                                aria-expanded="false"
                                            >
                                                <i className="fe fe-more-vertical" />
                                            </a>
                                            <div className="dropdown-menu dropdown-menu-end">
                                                <Link to="/ventoredit" className="dropdown-item">
                                                    Edit
                                                </Link>
                                                <Link to="" className="dropdown-item">
                                                    Remove
                                                </Link>
                                                {/* <Link to="" data-bs-toggle="modal" data-bs-target="#exampleModal" className="dropdown-item">
                                                        Block
                                                    </Link>
                                                    <Link to="#!" className="dropdown-item">
                                                        Other
                                                    </Link> */}
                                            </div>
                                        </div>
                                    </td>
                                </tr>

                                <tr>
                                    <td>3</td>
                                    <td>
                                        {/* Avatar */}
                                        <div className="avatar avatar-xs align-middle me-2">
                                            <img
                                                className="avatar-img rounded-circle"
                                                src="/images/profiledp.png"
                                                alt=""
                                            />
                                        </div>
                                        <a
                                            className="item-name text-reset"
                                            href=""
                                        >
                                            Jhon Joe
                                        </a>
                                    </td>
                                    <td>
                                        <span className="item-title">
                                            Virtual Office & Mailing...
                                        </span>
                                    </td>
                                    <td>
                                        <a
                                            className="item-email text-reset"
                                            href="mailto:user231@gmail.com"
                                        >
                                            user231@gmail.com
                                        </a>
                                    </td>
                                    <td>
                                        10th floor SPE Tower...
                                    </td>
                                    <td>
                                        <a
                                            className="item-phone text-reset"
                                            href="tel:+89687677578"
                                        >
                                            +89687677578
                                        </a>
                                    </td>
                                    <td className="text-end">
                                        <div className="dropdown">
                                            <a
                                                className="dropdown-ellipses dropdown-toggle"
                                                href=""
                                                role="button"
                                                data-bs-toggle="dropdown"
                                                aria-haspopup="true"
                                                aria-expanded="false"
                                            >
                                                <i className="fe fe-more-vertical" />
                                            </a>
                                            <div className="dropdown-menu dropdown-menu-end">
                                                <Link to="/ventoredit" className="dropdown-item">
                                                    Edit
                                                </Link>
                                                <Link to="" className="dropdown-item">
                                                    Remove
                                                </Link>
                                            </div>
                                        </div>
                                    </td>
                                </tr>

                                <tr>
                                    <td>4</td>
                                    <td>
                                        {/* Avatar */}
                                        <div className="avatar avatar-xs align-middle me-2">
                                            <img
                                                className="avatar-img rounded-circle"
                                                src="/images/profiledp.png"
                                                alt="..."
                                            />
                                        </div>
                                        <span
                                            className="item-name text-reset"
                                        >
                                            Jhon Joe
                                        </span>
                                    </td>
                                    <td>
                                        <span className="item-title">
                                            Virtual Office & Mailing...
                                        </span>
                                    </td>
                                    <td>
                                        <a
                                            className="item-email text-reset"
                                            href="mailto:user231@gmail.com"
                                        >
                                            user231@gmail.com
                                        </a>
                                    </td>
                                    <td>
                                        10th floor SPE Tower...
                                    </td>
                                    <td>
                                        <a
                                            className="item-phone text-reset"
                                            href="tel:+89687677578"
                                        >
                                            +89687677578
                                        </a>
                                    </td>
                                    <td className="text-end">
                                        <div className="dropdown">
                                            <a
                                                className="dropdown-ellipses dropdown-toggle"
                                                href=""
                                                role="button"
                                                data-bs-toggle="dropdown"
                                                aria-haspopup="true"
                                                aria-expanded="false"
                                            >
                                                <i className="fe fe-more-vertical" />
                                            </a>
                                            <div className="dropdown-menu dropdown-menu-end">
                                                <Link to="/ventoredit" className="dropdown-item">
                                                    Edit
                                                </Link>
                                                <Link to="" className="dropdown-item">
                                                    Remove
                                                </Link>
                                                <Link to="" data-bs-toggle="modal" data-bs-target="#exampleModal" className="dropdown-item">
                                                    Block
                                                </Link>
                                                <Link to="#!" className="dropdown-item">
                                                    Other
                                                </Link>
                                            </div>
                                        </div>
                                    </td>
                                </tr>

                            </tbody>
                        </table>
                    </div>

                </div>
            </div>
            {/* invite vindors popup code start here */}
            <div className="modal fade" id="exampleModal" tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header border-0">
                            <button type="button" className="btn-close block-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div className="modal-body pe-0 ps-0 block-user">
                            <img src="/images/invite.png" alt="" width={120} srcSet="" />
                            <h1 className="mb-0 mt-2">Invite Vendors</h1>
                            <p>Invite new vendor to create their profile in the portal <br /> Enter Email or other links to invite to the portal.</p>
                        </div>
                        <form action="" className="px-5">
                            <label
                                className="form-label text-start d-block"
                                htmlFor="email"
                            >
                                Email address
                            </label>
                            <div className="position-relative">
                                <input
                                    className="form-control"
                                    type="email"
                                    id="email"
                                    placeholder="@example.com"
                                />
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width={16}
                                    height={16}
                                    fill="currentColor"
                                    className="bi bi-envelope-fill input-icon"
                                    viewBox="0 0 16 16"
                                >
                                    <path d="M.05 3.555A2 2 0 0 1 2 2h12a2 2 0 0 1 1.95 1.555L8 8.414.05 3.555ZM0 4.697v7.104l5.803-3.558L0 4.697ZM6.761 8.83l-6.57 4.027A2 2 0 0 0 2 14h12a2 2 0 0 0 1.808-1.144l-6.57-4.027L8 9.586l-1.239-.757Zm3.436-.586L16 11.801V4.697l-5.803 3.546Z" />
                                </svg>
                            </div>
                            <br />
                            <label
                                className="form-label text-start d-block"
                                htmlFor="modal"
                            >
                                Module
                            </label>
                            <select name="" id="" className="form-select form-control">
                                <option value="">Select module</option>
                                <option value="">Shopping</option>
                                <option value="">Job</option>
                                <option value="">Ticket</option>
                                <option value="">Other</option>
                            </select>
                        </form>
                        <br />
                        <div className="modal-footer pe-0 ps-0 border-0 justify-content-center pt-0 mb-3">
                            <button type="button" className="btn-custom w-auto">SEND</button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
